import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ProviderInvoiceDetailBulkModel } from 'src/app/models/shopping/provider-invoice-detail-bulk.model';
import { ProviderInvoiceDetailModel } from 'src/app/models/shopping/provider-invoice-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProviderInvoiceDetailService {

  private readonly _httpClient = inject(HttpClient);

  createProviderInvoiceDetail(providerInvoiceDetail: ProviderInvoiceDetailModel): Observable<ProviderInvoiceDetailModel> {
    return this._httpClient.post<ProviderInvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.CreateProviderInvoiceDetail}`,
      providerInvoiceDetail);
  }

  createBulkProviderInvoiceDetail(request: ProviderInvoiceDetailBulkModel): Observable<ProviderInvoiceDetailModel[]> {
    return this._httpClient.post<ProviderInvoiceDetailModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.CreateBulkProviderInvoiceDetail}`,
      request);
  }

  deleteProviderInvoiceDetail(providerInvoiceDetailId: number): Observable<ProviderInvoiceDetailModel> {
    const params = new HttpParams().set('providerInvoiceDetailId', providerInvoiceDetailId);
    return this._httpClient.delete<ProviderInvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.DeleteProviderInvoiceDetail}`,
      { params: params }
    );
  }

  deleteSomeDetails(providerInvoiceDetailIds: Array<number>): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.DeleteSomeDetailsAsync}`,
      providerInvoiceDetailIds
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getColumnsForDetailsProviderInvoice(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.GetColumnsForDetailsProviderInvoiceAsync}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.GetColumnsForGeneralConsultation}`);
  }

  getProviderInvoiceDetailById(providerInvoiceDetailId: number): Observable<ProviderInvoiceDetailModel> {
    const params = new HttpParams().set('providerInvoiceDetailId', providerInvoiceDetailId);
    return this._httpClient.get<ProviderInvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.GetProviderInvoiceDetailById}`,
      { params: params }
    );
  }

  getProviderInvoiceDetailByKeys(providerInvoiceId: number, articleId: number, conceptInvoicingId: number): Observable<ProviderInvoiceDetailModel> {
    const params = new HttpParams()
      .set('providerInvoiceId', providerInvoiceId)
      .set('articleId', articleId)
      .set('conceptInvoicingId', conceptInvoicingId);
    return this._httpClient.get<ProviderInvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.GetProviderInvoiceDetailByKeysAsync}`,
      { params: params }
    );
  }

  getProviderInvoiceDetailsByProviderInvoiceIdWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, providerInvoiceId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant)
      .set('providerInvoiceId', providerInvoiceId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.GetProviderInvoiceDetailsByProviderInvoiceIdWithPagination}`,
      { params }
    );
  }

  getProviderInvoiceDetailsForGeneralConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.GetProviderInvoiceDetailsForGeneralConsultation}`,
      filters, { params: params }
    );
  }

  updateProviderInvoiceDetail(providerInvoiceDetail: ProviderInvoiceDetailModel): Observable<ProviderInvoiceDetailModel> {
    return this._httpClient.put<ProviderInvoiceDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.providerInvoiceDetail.UpdateProviderInvoiceDetail}`,
      providerInvoiceDetail);
  }
}
